<template>
  <v-row
    justify="start"
    align="center"
    class="ma-0"
  >
    <v-col
      cols="12"
    >
      <v-flex
        class="d-flex flex-column"
      >
        <v-flex class="d-flex">
          <span class="subtitle-1 font-weight-bold">Preço Total:</span>
          <v-spacer/>
          <span class="subtitle-1 font-weight-bold">{{currencySymbol}} {{item["fl_total_price"] | toFixedWithComma}}</span>
        </v-flex>
        <v-flex
          v-if="mustShowDiscount"
          class="d-flex"
        >
          <span class="body-2 font-weight-bold grey--text">Descontos:</span>
          <v-spacer/>
          <span class="body-2 font-weight-bold grey--text">{{currencySymbol}} {{item["fl_total_discount"] | toFixedWithComma}}</span>
        </v-flex>
        <v-divider
          class="my-2"
        />
        <v-flex class="d-flex">
          <span class="subtitle-1 font-weight-bold blue--text">Preço final:</span>
          <v-spacer/>
          <span class="subtitle-1 font-weight-bold blue--text">{{currencySymbol}} {{item["fl_final_price"] | toFixedWithComma}}</span>
        </v-flex>
      </v-flex>
    </v-col>
  </v-row>
</template>

<script>
  import {isEqual} from "lodash/lang"

  export default {
    name: "CartSummary",
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    filters: {
      toFixedWithComma(value) {
        return value.toFixed(2).replace(".", ",")
      }
    },
    computed: {
      mustShowDiscount() {
        return !isEqual(this.item["fl_total_discount"], 0)
      },
      currencySymbol() {
        if (this.$appMng.isIntl)
          return "$"
        return "R$"
      }
    }
  }
</script>

<style scoped>

</style>
